import styled from '@emotion/styled';
import { Box, Typography, Button } from '@mui/material';
import * as React from 'react';
import { FC, useState } from 'react';

import { Colors } from '@/assets';

const BoxChoise = styled(Button)({
    height: 37,
    px: 0,
    minWidth: 0,
    borderRadius: '30px',
    display: 'flex',
    boxShadow: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 2,
    ':hover h6': {
        color: Colors.orangeRed
    }
});

interface IProps {
    width?: number;
    choises: string[] | number[];
}
export const PrimaryChoises: FC<IProps> = ({ width = 71, choises = [] }) => {
    const [value, setValue] = useState<number | string>(choises[0]);

    const indexSelected = choises.findIndex((item) => item === value);
    return (
        <Box
            sx={{
                background: Colors.zirconGrey,
                borderRadius: '30px',
                display: 'inline-flex',
                position: 'relative'
            }}
        >
            <Box
                sx={{
                    left: `${(100 / choises.length) * indexSelected}%`,
                    transition: 'left 0.2s ease-in-out',
                    position: 'absolute',
                    height: 37,
                    width: width,
                    border: '2px solid',
                    borderColor: Colors.geyserGrey,
                    background: Colors.white,
                    borderRadius: '30px'
                }}
            ></Box>
            {choises.map((item, index) => {
                const isSelected = value === item;
                return (
                    <BoxChoise
                        onClick={() => setValue(item)}
                        key={index}
                        sx={{
                            width: width
                        }}
                    >
                        <Typography sx={{ color: isSelected ? Colors.orangeRed : Colors.charcoalGrey }} variant="subtitle2">
                            {item}
                        </Typography>
                    </BoxChoise>
                );
            })}
        </Box>
    );
};
